<template>
  <!-- 选择商品弹窗 -->
  <y-dialog
    title="选择商品"
    :visible.sync="selectDialog"
    width="1240px"
    @close="handleDialogClose"
    @comfirm="handleDialogConfirm"
  >
    <template slot="title">
      <span>选择商品</span>
    </template>
    <div class="goods global-content-flex">
      <!-- 筛选部分 -->
      <y-form
        :form-info="formInfo"
        width="280px"
        @search="searchList"
        @selfReset="searchReset"
      >
        <!-- 自定义插槽 -->
        <template #checkedBrands>
          <!-- 指定品牌弹出框 -->
          <y-shop-by-platform
            ref="yShopByPlatformRef"
            class="select-platform"
            :shopData="ScoresCardShopList"
            :defaultValue="true"
            :showAll="false"
            @change="shopChange"
            @platformChange="classifyChange"
            @init="getTaobaoItemList"
          ></y-shop-by-platform>
        </template>
        <template #classifyValue>
          <div class="flexc-cen-x">
            <el-popover
              placement="bottom"
              width="300"
              v-model="visible"
              popper-class="poper"
            >
              <div class="popper-wrapper">
                <el-tree
                  ref="sellerTree"
                  node-key="id"
                  :data="sellerCats"
                  :props="props"
                  show-checkbox
                ></el-tree>
              </div>
              <div style="text-align: right; margin-top: 20px">
                <el-checkbox
                  v-model="checkedAll"
                  @change="handleCheckAllChangeTaoBao"
                  style="float: left; line-height: 26px"
                  >全选</el-checkbox
                >
                <y-button size="mini" type="blueText" @click="visible = false"
                  >取消</y-button
                >
                <y-button type="blue" size="mini" @click="getCheckedKeys()"
                  >确定</y-button
                >
              </div>
              <y-button slot="reference" size="small" class="goods-button">
                {{
                  classifyIdArray.length > 0
                    ? "已选择" + classifyIdArray.length + "项"
                    : "默认全部"
                }}
              </y-button>
            </el-popover>
          </div>
        </template>
      </y-form>
      <!-- 表格部分 -->
      <div class="table-box global-felx-1">
        <div class="table-left">
          <y-table
            :tableInfo="tableInfo"
            :pageInfo="{
              pageNum: leftPaginationInfo.current,
              pageSize: leftPaginationInfo.pageSize,
              total: leftPaginationInfo.total,
            }"
            :tableData="leftData"
            :loading="tableLoading"
            :rowClassNameFn="tableRowClassName"
            :pagerCount="5"
            @handlePage="leftCurrentChange"
          >
            <template #itemTitle="scope">
              <div class="goods-wrap">
                <img :src="scope.row.picUrl" class="goods-img" alt />
                <div class="goods-content">
                  <span
                    class="goods-title"
                    @click="toGoodDetail(scope.row.itemLink)"
                    >{{ scope.row.itemTitle }}</span
                  >
                  <div class="goods-detail">
                    <span class="goods-id">商品ID:{{ scope.row.numIid }}</span>
                    <span class="goods-price"
                      >￥<span class="price">{{ scope.row.price }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template #operateHead>
              <div class="flex-cen-xy">
                <y-button
                  size="small"
                  type="blueText"
                  @click="handleAllSelect()"
                  style="font-size: 14px"
                  >全选</y-button
                >
              </div>
            </template>
            <template #operate="scope">
              <div class="flex-cen-xy">
                <img
                  class="addBtn addDisabled"
                  src="@/assets/images/btn_添加.svg"
                  @click="handleSelect(scope.row, scope.rowIndex)"
                  v-if="scope.row.state === true"
                />
                <img
                  class="addBtn"
                  src="@/assets/images/btn_添加.svg"
                  style="cursor: pointer"
                  v-else
                  @click="handleSelect(scope.row, scope.rowIndex)"
                />
              </div>
            </template>
          </y-table>
        </div>
        <div class="table-right">
          <y-table
            :tableInfo="tableInfoRight"
            :pageInfo="{
              pageNum: rightPaginationInfo.tableCurrentPage,
              pageSize: rightPaginationInfo.pageSize,
              total: rightPaginationInfo.totalCount,
            }"
            :tableData="rightDataNow"
            :pagerCount="5"
            @handlePage="rightCurrentChange"
          >
            <template #itemTitleHead>
              <span>已选择宝贝</span>
              <span class="is-select"
                >({{ rightPaginationInfo.totalCount }})</span
              >
            </template>
            <template #itemTitle="scope">
              <div class="goods-wrap">
                <img :src="scope.row.picUrl" class="goods-img" alt />
                <div class="goods-content">
                  <span
                    class="goods-title"
                    @click="toGoodDetail(scope.row.itemLink)"
                    >{{ scope.row.itemTitle }}</span
                  >
                  <div class="goods-detail">
                    <span class="goods-id">商品ID:{{ scope.row.numIid }}</span>
                    <span class="goods-price"
                      >￥<span class="price">{{ scope.row.price }}</span>
                    </span>
                  </div>
                  <el-popover
                    v-if="skuIsShow"
                    placement="bottom-start"
                    width="250"
                    trigger="click"
                    popper-class="sku-popover"
                  >
                    <div class="specsList">
                      <span
                        :class="{ active: info.skuIsActive }"
                        v-for="info in scope.row.skuId"
                        :key="info.skuId"
                        @click="selectSkuInfo(info, scope.row)"
                      >
                        {{ info.propertiesName }}
                      </span>
                    </div>

                    <div
                      slot="reference"
                      class="selectSku"
                      v-show="scope.row.skuId && scope.row.skuId.length > 0"
                    >
                      选择SKU<span v-if="scope.row.skuIdlen > 0"
                        >({{ scope.row.skuIdlen }})</span
                      >
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
            <template #operateHead>
              <div class="flex-cen-xy">
                <y-button
                  size="small"
                  type="blueText"
                  @click="handleClear()"
                  style="font-size: 14px"
                  >清空</y-button
                >
              </div>
            </template>
            <template #operate="scope">
              <div class="flex-cen-xy">
                <img
                  class="addBtn"
                  src="@/assets/images/btn_删除.svg"
                  style="cursor: pointer"
                  @click="handleDelete(scope.row, scope.rowIndex)"
                />
              </div>
            </template>
          </y-table>
        </div>
      </div>
    </div>
  </y-dialog>
</template>

<script>
import {
  getBrandList,
  getSellercats,
  getTaobaoItemSkuList,
  getTaobaoItemList,
  getScoresCardShopList,
} from "@/api/public";
import { mapState } from "vuex";
export default {
  name: "select-goods",
  props: {
    postForm: {
      type: Array,
    },
    shopType: {
      type: Number,
      default: 0,
    },
    skuIsShow: {
      type: Boolean,
      default: true,
    },
    shopId: {
      // 绑定店铺ID
      // type: String,
      default: "",
    },
    platform: {
      // 平台
      type: String,
      default: "",
    },
    scoresCardId: {
      // type: String,
      default: "",
    },
  },
  watch: {
    rightData(nval, oval) {
      this.rightDataNow = nval.slice(
        (this.rightPaginationInfo.tableCurrentPage - 1) *
          this.rightPaginationInfo.pageSize,
        this.rightPaginationInfo.tableCurrentPage *
          this.rightPaginationInfo.pageSize
      );
    },
  },
  data() {
    return {
      formInfo: [
        {
          label: "选择店铺：",
          prop: "checkedBrands",
          slot: "checkedBrands",
        },
        {
          label: "商品名称：",
          prop: "itemTitle",
          type: "Input",
          placeholder: "请输入商品名称",
        },
        {
          label: "选择类目：",
          prop: "classifyValue",
          slot: "classifyValue",
        },
        {
          label: "商品ID：",
          prop: "numIid",
          type: "Input",
          placeholder: "请输入商品ID",
        },
        {
          label: "商品状态：",
          prop: "goodValue",
          type: "Select",
          value: "",
          placeholder: "全部商品",
          options: [
            {
              value: "",
              label: "全部",
            },
            {
              value: 0,
              label: "上架",
            },
            {
              value: 1,
              label: "下架",
            },
            {
              value: 2,
              label: "已删除",
            },
          ],
        },
      ],
      pageInfo: {
        pageNum: 1,
        pageSize: 1000,
      },
      tableInfo: [
        {
          label: "店中宝贝",
          prop: "itemTitle",
          slot: "itemTitle",
          align: "center",
        },
        {
          label: "",
          prop: "operate",
          slotHead: "operateHead",
          slot: "operate",
          width: 100,
        },
      ],
      tableInfoRight: [
        {
          prop: "itemTitle",
          slot: "itemTitle",
          slotHead: "itemTitleHead",
          align: "center",
        },
        {
          label: "",
          prop: "operate",
          slotHead: "operateHead",
          slot: "operate",
          width: 100,
        },
      ],
      ScoresCardShopList: [],
      tableLoading: false,
      selectDialog: true,
      brandVisible: false, //指定品牌弹出框
      brandOptions: "", //品牌列表
      checkedBrands: "", //选中品牌
      checkedBrandsString: "", //选中的品牌ID
      isIndeterminate: true,
      checkAll: false,
      checkedAll: false,
      rightDataNow: [],
      classifyValue: "",
      classifyIndex: "",
      classifyIdArray: [],
      classifyIdString: "",
      visible: false, //类目渲染
      /*
       * 商品状态相关
       * */
      goodValue: "",
      /*
       * 树形选择相关
       * */
      sellerCats: [], //店铺类目
      props: {
        label: "speName001",
        children: "child",
      },
      itemTitle: "", //商品名称
      numIid: "", //商品id
      /*
       * 选择商品左侧表格
       * */
      leftData: [],
      newData: [],
      alreadyList: [],
      /*
       * 左侧商品分页数据
       * */
      leftPaginationInfo: {
        current: 1, //当前页数
        pageSize: 10, //当前页面数据大小
        total: 0, //数据总数
      },
      /*
       * 选择商品右侧表格
       * */
      rightData: [],
      /*
       * 右侧商品分页数据
       * */
      rightPaginationInfo: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
    };
  },
  computed: {
    ...mapState({
      Warenauswahl: "Warenauswahl",
      excludeList: "excludeList",
      assignList: "assignList",
      globalBG: "globalBG",
    }),
  },
  beforeCreate() {},
  beforeMount() {},
  created() {
    // 获取当前会员体系详情
    console.log(this.MemberSystemInfo);
    let self = this;
    let alreadyList = [];
    console.log("this.postForm ", this.postForm);
    if (this.postForm && this.postForm.length > 0) {
      alreadyList = JSON.parse(JSON.stringify(self.postForm));
    }
    for (let i = 0; i < alreadyList.length; i++) {
      alreadyList[i].state = true;
    }
    this.rightData = JSON.parse(JSON.stringify(alreadyList));
    this.rightPaginationInfo.totalCount = this.rightData.length;
  },
  mounted() {
    this.getScoresCardShopList();
  },
  methods: {
    // 查询已关联的店铺列表
    getScoresCardShopList() {
      getScoresCardShopList({
        ...this.pageInfo,
        scoresCardId: this.scoresCardId,
      }).then((res) => {
        console.log(res, "查询已关联的店铺列表");
        if (res.data.dataList && res.data.dataList.length) {
          this.ScoresCardShopList = res.data.dataList.map((item) => {
            return {
              label: item.shopTitle,
              value: item.channelSellerManageId,
              platform: item.platform,
            };
          });
        }
      });
    },
    /**
     * 获取淘宝sku属性
     */
    getTaobaoItemSku(id) {
      let skuArr = [];
      getTaobaoItemSkuList({
        numIid: id,
        cardId: this.shopId,
      }).then((res) => {
        res.data.forEach((item) => {
          let str = "",
            arr = null;
          arr = item.propertiesName.split(";");

          arr.forEach((d, idx) => {
            let sku = d.split(":");
            if (idx == arr.length - 1) {
              str += sku[sku.length - 1];
            } else {
              str += sku[sku.length - 1] + "; ";
            }
          });
          skuArr.push({
            propertiesName: str,
            skuId: item.skuId,
            skuIsActive: false,
          });
        });
      });

      return skuArr;
    },

    /**
     * 商品sku属性选中
     */
    selectSkuInfo(info, row) {
      info.skuIsActive = !info.skuIsActive;
      if (info.skuIsActive) {
        row.skuIdlen++;
      } else {
        row.skuIdlen--;
      }
    },
    /**
     *  获取店铺类目
     */
    getSellercats() {
      getSellercats({ channelSellerManageId: this.checkedBrands }).then(
        (res) => {
          // console.log("%c 品牌列表", "color: green", res.data);
          this.sellerCats = res.data;
        }
      );
    },

    /**
     *  获取品牌列表
     */
    getBrandList() {
      getBrandList({ channelSellerManageId: this.shopId }).then((res) => {
        // console.log("%c 品牌列表", "color: green", res.data);
        this.brandOptions = res.data;
      });
    },

    validNum(val) {
      console.log(val);
      this.numIid = val.replace(/[^0-9,]+/g, "");
    },
    changeNum(val) {
      let that = this,
        testArr = [];
      this.numIid.split(",").forEach((val) => {
        if (val != "" && /^[0-9]+$/.test(val)) {
          testArr.push(val);
        }
      });
      this.numIid = testArr.join(",");
    },
    // 跳到对应商品购买页
    toGoodDetail(val) {
      if (val.length > 0) {
        window.open(val, "_blank");
      }
    },
    /*
     * 商品类目全选按钮监听事件
     * */
    handleCheckAllChangeTaoBao(val) {
      console.log(val, "val111111111");

      if (val) {
        this.$refs.sellerTree.setCheckedNodes(this.sellerCats);
      } else {
        this.$refs.sellerTree.setCheckedNodes([]);
      }
    },
    handleCheckAllChange(val) {
      // console.log("%c 品牌全选事件", "color: green", val);
      // this.checkedBrands = val ? this.brandOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedBrandsChange(value) {
      // console.log("%c 品牌单选事件", "color: green", value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.brandOptions.length;
    },
    /*
     * 切换平台
     * */
    classifyChange(value) {
      this.classifyIndex = value;
      this.checkedAll = false;
      this.classifyIdArray = [];
      this.classifyIdString = "";
    },
    /*
     * 确认类目事件
     * */
    getCheckedKeys() {
      const classifyIdArray = this.$refs.sellerTree.getCheckedKeys();
      this.classifyIdArray = classifyIdArray;
      this.classifyIdString = classifyIdArray.join(",");
      this.visible = false;
    },
    /*
     * 弹窗确认事件
     * */
    handleDialogConfirm() {
      const that = this;
      let rightData = that.rightData;
      // let numIids = [];
      // console.log(that.modelName.type)
      if (rightData.length > 0) {
        rightData.forEach(function (value) {
          value.type = that.$store.state.modelName.type;
          value.Warenauswahl = that.Warenauswahl;
        });
        // console.log(numIids);
        // console.log(rightData);
        // console.log(that.leftData)
        rightData[0].shopType = this.shopType;
      } else {
        this.$emit("myShopType", this.shopType);
      }

      this.$emit("transferName", rightData, 1);
      this.selectDialog = true;
    },
    /*
     * 弹窗关闭事件
     * */
    handleDialogClose() {
      const that = this;
      console.log(that.Warenauswahl);
      let rightData = that.rightData;
      rightData.forEach(function (value) {
        value.type = that.$store.state.modelName.type;
        value.Warenauswahl = that.Warenauswahl;
      });
      this.$emit("transferName", [], 0);
      this.selectDialog = true;
    },
    /*
     * 获取淘宝商品列表
     * */
    getTaobaoItemList() {
      /**
       * approveStatus (string, optional): 商品状态 不填查全部，在售 1，待售 2 ,//
        categoryType (string, optional): 商品类目类型 0店铺类目 1淘宝类目 ,//
        cid (string, optional): 商品类目ID 勾选父级 传入相应子集 英文逗号拼接 1,2,3 ,//
        endPrice (string, optional): 商品价格区间 ,//
        itemTitle (string, optional): 商品名称 ,//
        numIid (string, optional): 商品id ,itemTitle -//
        pageNum (integer, optional): 当前页 ,//
        pageSize (integer, optional): 每页大小 ,//
        pid (string, optional): 商品品牌ID 英文逗号拼接 1,2,3 ,//
        startPrice (string, optional): 商品价格区间//
       */
      const self = this;
      let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
        classifyIdString = self.classifyIdString, //宝贝类目id数组
        itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
        goodValue = self.goodValue; //商品状态
      var formData = {
        approveStatus: goodValue,
        categoryType: 1,
        cid: classifyIdString,
        itemTitle: itemTitle, //商品名称
        numIid: self.numIid, //商品id
        pageNum: self.leftPaginationInfo.current,
        pageSize: self.leftPaginationInfo.pageSize,
        pid: checkedBrandsString,
        cardId: self.scoresCardId,
        channelSellerManageId: self.checkedBrands,
        platform: this.classifyIndex,
      };
      console.log(formData, "formData");
      this.tableLoading = true;
      getTaobaoItemList({ ...formData }).then((res) => {
        this.tableLoading = false;
        if (res.code === 200) {
          let dataList = res.data.dataList?res.data.dataList:[];
          //(function makearr(arr){console.log(arr);if(arr && arr.length<10000){makearr([...JSON.parse(JSON.stringify(arr)),...JSON.parse(JSON.stringify(arr))])}else{dataList=arr;return;}})(dataList);
          // for (let i = 0; i < dataList.length; i++) {
          //  dataList[i].numIid = i;
          // }

          //dataList=dataList.splice((formData.pageNum-1)*formData.pageSize,formData.pageSize);
          //给商品列表添加一个state属性判断是否可以被选中
          for (let i = 0; i < dataList.length; i++) {
            dataList[i].state = false;
            dataList[i].skuIdlen = 0;
          }
          self.newData = dataList;
          self.leftData = dataList;
          //根据右边判断
          if (self.rightData.length === 0) {
            // 首次加载
            // console.log("首次加载");
            // self.leftData = dataList
          } else {
            // console.log("已有数据");
            // console.log(self.leftData);
            //获取的数据与原数据对比(numIid),无则追加，有则跳过
            let nowList = self.newData; //当前新获取的数据
            let newList = []; //不存在旧数据的临时数据
            for (const newItem of nowList) {
              let i = 0;
              for (const oldItem of self.rightData) {
                i++;
                if (newItem.numIid != oldItem.numIid) {
                  if (i === self.rightData.length) {
                    // 内层循环完新添加进新数组
                    newList.push(newItem);
                  }
                  continue;
                } else {
                  break;
                }
              }
            }
            // 追加新加的元素 (右边和最新数据对比过滤)
            // console.log(newList);
            if (newList.length === 0) {
              for (const item of self.leftData) {
                item.state = true;
              }
            } else {
              for (const item1 of self.leftData) {
                let i = 0;
                for (const item of newList) {
                  i++;
                  if (item1.numIid != item.numIid) {
                    if (i === newList.length) {
                      // 内层循环完新添加进新数组
                      item1.state = true;
                    }
                    continue;
                  } else {
                    break;
                  }
                }
              }
            }
          }
          self.leftPaginationInfo.total = res.data.pageInfo?res.data.pageInfo.total:0;
        }
      });
    },
    /*
     * 左侧商品分页事件
     * */
    leftCurrentChange(event) {
      this.leftPaginationInfo.current = event.pageNum;
      this.leftPaginationInfo.pageSize = event.pageSize;
      this.getTaobaoItemList();
    },
    /*
     * 左侧表格单选按钮
     * */
    async handleSelect(row, index) {
      const that = this;
      // 获取商品sku信息
      let skuArr = await this.getTaobaoItemSku(row.numIid);

      let leftData = that.leftData;
      let rightData = that.rightData;
      if (row.state === false) {
        this.$set(row, "skuId", skuArr);

        rightData.push(row);
        leftData[index].state = true;
      }
      that.leftData = leftData;
      that.rightData = rightData;

      that.rightPaginationInfo.totalCount = rightData.length;
    },
    /*
     * 左侧表格全选按钮
     * */
    handleAllSelect() {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;
      // if(leftData.length>=500){
      //     this.$message.warning("商品最多只能选择500个");
      //     return;
      // }
      for (let i = 0; i < leftData.length; i++) {
        if (leftData[i].state === false) {
          let skuArr = this.getTaobaoItemSku(leftData[i].numIid);
          this.$set(leftData[i], "skuId", skuArr);
          rightData.push(leftData[i]);
          leftData[i].state = true;
        }
      }
      that.leftData = leftData;
      that.rightData = rightData;
      that.rightPaginationInfo.totalCount = rightData.length;
    },
    /*
     * 左侧表格状态颜色
     * */
    tableRowClassName({ row }) {
      console.log(row);
      if (row.state === true) {
        return "success-row";
      }
      return "";
    },
    /*
     * 右侧表格删除按钮
     * */
    handleDelete(row, index) {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;
      rightData.splice(index, 1);
      for (let i = 0; i < leftData.length; i++) {
        if (leftData[i].numIid == row.numIid) {
          that.leftData[i].state = false;
        }
      }
      that.rightPaginationInfo.totalCount = rightData.length;
      that.rightData = rightData;
    },
    /*
     * 右侧表格清空按钮
     * */
    handleClear() {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;

      for (let i = 0; i < rightData.length; i++) {
        for (let j = 0; j < leftData.length; j++) {
          if (rightData[i].numIid == leftData[j].numIid) {
            leftData[j].state = false;
          }
        }
      }
      that.leftData = leftData;

      rightData.splice(0, rightData.length);
      that.rightPaginationInfo.totalCount = 0;
    },
    /*
     * 右侧分页事件
     * */
    rightCurrentChange(val) {
      this.rightPaginationInfo.pageSize = val.pageSize;
      this.rightPaginationInfo.tableCurrentPage = val.pageNum;
      this.rightDataNow = this.rightData.slice(
        (this.rightPaginationInfo.tableCurrentPage - 1) *
          this.rightPaginationInfo.pageSize,
        this.rightPaginationInfo.tableCurrentPage *
          this.rightPaginationInfo.pageSize
      );
    },
    /*
     * 查询按钮
     * */
    searchList(val) {
      this.itemTitle = val.itemTitle;
      this.numIid = val.numIid;
      this.goodValue = val.goodValue;
      // 执行查询接口
      this.getTaobaoItemList();
    },
    // 重置
    searchReset() {
      this.checkedBrands = "";
      this.classifyValue = "";
      this.classifyIndex = "";
      this.classifyIdArray = [];
      this.classifyIdString = "";
      this.$refs.yShopByPlatformRef.reset();
    },
    // 选择店铺
    shopChange(platform, shop) {
      this.classifyIndex = platform;
      this.checkedBrands = shop;
      this.getSellercats();
    },
  },
};
</script>

<style lang="scss">
.sku-popover {
  padding: 10px !important;
  max-height: 600px;
  overflow-y: auto;
}
</style>

<style lang="scss" scoped>
.select-platform {
  /deep/ .box-shop {
    width: 175px;
  }
}

/deep/ .el-table .success-row {
  background: #f5f7fa;
  cursor: not-allowed;
  opacity: 0.4;
}
.el-table tr {
  .addBtn {
    display: none;
  }

  &:hover {
    .addBtn {
      display: inline-block;
    }
  }
}
.goods {
  height: 666px;
}
.goods-button {
  /deep/ .el-button {
    width: 280px;
  }
}
/deep/ .el-pagination {
  text-align: left !important;
}
.table-box {
  display: flex;
  margin-top: 16px;
}
.table-left {
  flex: 1;
  overflow: hidden;
  height: 100%;
  // overflow: hidden;
  .goods-img {
    width: 56px;
    margin-right: 7px;
  }
  .goods-content {
    width: 331px;
    .goods-title {
      display: block;
      text-align: left;
      margin-bottom: 6px;
    }
    .goods-title:hover {
      color: $theme-color;
      cursor: pointer;
      text-decoration: underline;
    }
    .goods-detail {
      display: block;
      overflow: hidden;
      .goods-id {
        display: block;
        float: left;
        color: #999999;
      }
      .goods-price {
        display: block;
        float: right;
        color: #ff7700;
        .price {
          font-size: 13px;
        }
      }
    }
  }
  .add-button {
    font-size: 24px;
    cursor: pointer;
  }
  .addDisabled {
    cursor: not-allowed;
  }
}
.table-right {
  flex: 1;
  margin-left: 20px;
  overflow: hidden;
  height: 100%;
  .is-select {
    color: #ff7600;
  }
  .goods-img {
    width: 56px;
    margin-right: 7px;
  }
  .goods-content {
    width: 331px;
    .goods-title {
      display: block;
      text-align: left;
      margin-bottom: 6px;
    }
    .goods-title:hover {
      color: $theme-color;
      cursor: pointer;
      text-decoration: underline;
    }
    .goods-detail {
      display: block;
      overflow: hidden;
      .goods-id {
        display: block;
        float: left;
        color: #999999;
      }
      .goods-price {
        display: block;
        float: right;
        color: #ff7700;
        .price {
          font-size: 13px;
        }
      }
    }
    .selectSku {
      text-align: left;
      color: $theme-color;
      cursor: pointer;
    }
  }
  .delete-button {
    font-size: 24px;
    cursor: pointer;
  }
}
.goods-wrap {
  display: flex;
  padding: 10px 0px;
}
/* 滚动条样式修改 */
.popper-wrapper,
.el-checkbox-group {
  /* background-color: #666; */
  max-height: 250px !important;
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-checkbox-group::-webkit-scrollbar,
.popper-wrapper::-webkit-scrollbar {
  width: 0px;
  background-color: #fff;
  border-radius: 10px;
  padding: 5px 0;
}
.el-checkbox-group:hover::-webkit-scrollbar,
.popper-wrapper:hover::-webkit-scrollbar {
  width: 6px;
}
.el-checkbox-group::-webkit-scrollbar,
.popper-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #d6d8dd;
  overflow: hidden;
}

.item-name {
  width: 72px;
  display: inline-block;
  text-align: right;
}
.search_btn {
  width: 96px;
  height: 32px;
  // background:#5882FB;
  opacity: 1;
  border-radius: 2px;
  font-size: 14px;
  padding: 0px;
}
.addDisabled {
  cursor: not-allowed;
}
.specsList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    margin-right: 6px;
    margin-bottom: 6px;
    padding: 4px 8px;
    border: 1px solid #f3f3f3;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #fff;
    background-color: #5882fb;
  }
}
</style>
